/**
 * SNAP-2424: the recovery and cancel links carry their token in the fragment. Before the router,
 * analytics or Sentry read the URL, this moves the token out of the address bar and keeps it in
 * memory for the one page that asks for it. A reload shows the redacted address, which reads as an
 * invalid link, and the token is not stored anywhere else.
 */
const REDACTED = 'redacted';
const RECOVERY_FRAGMENT = /^#\/account-recovery\/(cancel\/)?([^/?#]+)$/;

let pendingToken: string | null = null;

export const stripAccountRecoveryTokenFromUrl = (
  location: Pick<Location, 'hash' | 'pathname' | 'search'> = window.location,
  history: Pick<History, 'replaceState' | 'state'> = window.history
): void => {
  const match = RECOVERY_FRAGMENT.exec(location.hash);
  if (!match || match[2] === REDACTED) return;

  pendingToken = match[2];
  const cancelPrefix = match[1] ?? '';
  history.replaceState(
    history.state,
    '',
    `${location.pathname}${location.search}#/account-recovery/${cancelPrefix}${REDACTED}`
  );
};

/** Keeps a token that reached the router by an in-page fragment change, which does not reload the page. */
export const setPendingAccountRecoveryToken = (token: string): void => {
  pendingToken = token && token !== REDACTED ? token : null;
};

/** The token captured at load. Falls back to the route's value, which is `redacted` after a reload. */
export const takeAccountRecoveryToken = (routeToken?: string): string => {
  const token = pendingToken ?? routeToken ?? '';
  pendingToken = null;
  return token === REDACTED ? '' : token;
};
